import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Grid, Button, TextField, Typography } from '@mui/material';
import mainStyles from 'Styles/mainStyles';
import { useTranslation } from 'react-i18next';
import useEventListener from 'Hooks/useEventListener';


const ManualDevice = () => {
	const navigate = useNavigate();
	const classes = mainStyles();
	const { t } = useTranslation();

	const [deviceId, setDeviceId] = useState(null);

	const handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			handleConfirm();
		}
	};

	useEventListener('keypress', handleKeyPress);

	const handleConfirm = () => {
		navigate('/SKY' + deviceId)
	}
	return (
		<Container component="main" maxWidth="sm">
			<Grid container justifyContent={'center'} alignItems='center'>
				<div className={classes.onboardContainer}>
					<Typography variant="h4" className={classes.title}>{t('Tilføj Sensor-ID')}</Typography>
				</div>
				<div className={classes.onboardImageContainer}>
					<img src="/assets/skyen.png" alt="Skyen" className={classes.onboardImageSkyen} />
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body2" className={classes.title}>{t('Indtast de 5 tal efter SKY på enheden. Eks. 00010.')}</Typography>
				</div>
				<div className={classes.onboardContainer}>
					<TextField
						autoFocus
						id="sensorID"
						label={t('Sensor-ID')}
						variant="outlined"
						className={classes.textField}
						onChange={(event) => setDeviceId(event.target.value)}
						value={deviceId}
					/>
				</div>
				<Button onClick={handleConfirm} variant="contained" className={classes.greenButton}>{t('Vælg enhed')}</Button>
			</Grid>
		</Container>
		
	)

}

export default ManualDevice;